import React, { useContext, useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { Stack, Typography, CircularProgress, Button } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import ManageContent from './components/ManageContent';
import { DTBLibraryContext } from '../context';
import { TakeoverLayout } from '_lex/_layouts/TakeoverLayout';
import Properties from './components/Properties';
import PolicyReferences from './components/PolicyReferences';
import ManageQuiz from './components/ManageQuiz';
import Loading from 'views/App/Portal/Loading';
import { useSearchParams } from 'react-router-dom';

const DTBDetail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { isLoading, isError, editedData, isSaving, handleSave: handleSaveContext } = useContext(DTBLibraryContext);

  const [backButtonPath, setBackButtonPath] = useState<string>('/admin/dtbs');

  const packageid = searchParams.get('packageid');

  useEffect(() => {
    if (packageid) {
      setBackButtonPath(`/admin/dtbs/packages/${packageid}`);
    }
  }, [packageid]);

  const handleSave = async () => {
    if (packageid) {
      await handleSaveContext(true, `/admin/dtbs/packages/${packageid}`);
    } else {
      await handleSaveContext();
    }
  };

  const pageActions = (
    <Stack
      direction='row'
      spacing={2}
      alignItems='center'
      justifyContent={'end'}
    >
      <Button
        variant='contained'
        size='small'
        onClick={() => handleSave()}
        disabled={isLoading || isSaving}
        endIcon={isSaving ? <CircularProgress size={16} /> : undefined}
      >
        {t('dtbs.library.detail.save')}
      </Button>
    </Stack>
  );

  const renderConfigurationDrawer = () => {
    if (!editedData) return null;

    return (
      <Stack spacing={0}>
        <Properties
          name={editedData.name}
          level={editedData.level}
          jurisdiction={editedData.jurisdiction}
          manual={editedData.manual}
        />
        <PolicyReferences contentReferences={editedData.contentReferences} />
      </Stack>
    );
  };

  return (
    <TakeoverLayout
      pageTitle={
        editedData
          ? `${t('dtbs.library.detail.title')} - ${parse(editedData.name || '')}`
          : t('dtbs.library.detail.title')
      }
      backUrl={backButtonPath}
      contentHeaderRight={pageActions}
      rightDrawer={{
        header: t('dtbs.library.detail.configuration'),
        content: renderConfigurationDrawer(),
        noPadding: true,
        wide: true,
      }}
    >
      {isLoading && <Loading />}
      {isError && (
        <Typography
          color='error'
          sx={{ mb: 2 }}
        >
          {t('common.error')}
        </Typography>
      )}

      {!isLoading && !isError && editedData && (
        <Stack
          spacing={4}
          sx={{ width: 800, maxWidth: '94%', mx: 'auto' }}
        >
          <ManageContent />
          <ManageQuiz />
        </Stack>
      )}
    </TakeoverLayout>
  );
};

export default DTBDetail;
